<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"> </CommonBreadCrumbs>
    <div>
      <NuxtLayout name="center">
        <div class="text-center mb-28">
          <h1>{{ dataLists.page_title }}</h1>
          <div class="h1-subtitle mb-10 md:mb-14 mt-4 md:mt-0">
            {{ dataLists.data.topic.title }}
          </div>
          <div
            class="text-lg leading-6 text-[#991e66] font-bold text-left md:ml-16 mb-12"
          >
            <div class="inline-flex">
              <NuxtLinkLocale
                :locale="switchBlogLocale()"
                :to="'/faqs'"
                class="flex"
              >
                <NuxtImg
                  loading="lazy"
                  src="/icons/arrow-left.svg"
                  class="mr-1"
                  alt="left arrow icon"
                  width="12"
                  height="24"
                />
                {{ $t("faq.return2Topics") }}
              </NuxtLinkLocale>
            </div>
          </div>
          <!-- <h2 class="text-primary">FAQ Topic Title</h2> -->

          <CommonAccordian
            class="md:mx-36 lg:mx-48 my-18"
            v-if="dataLists.data.items.length > 0"
            :dataLists="dataLists.data.items"
          ></CommonAccordian>
          <div v-else>{{ $t("faq.noFaq") }}</div>
        </div>

        <CommonLiveChatBlock></CommonLiveChatBlock>
      </NuxtLayout>
    </div>
  </div>
</template>

<script setup>
const route = useRoute();

const { data: dataLists, refresh } = await useFaqDetail(route.params.slug);
watch(
  () => route.params.slug,
  () => {
    refresh();
  },
);

useMetaTitles(dataLists.value.data.topic);

const breadcrumbs = getBreadcrumbs("faqs-topic", dataLists.value.data);

generateSchema("faqs-topic", dataLists.value.data.items);
</script>
